export default __webpack_public_path__ + "static/media/websiteScreens2.25ce0ec5.png";